module.exports = __webpack_public_path__ + "static/media/keyboard.1fd9f052.svg";